export const LOCALIZATION_KEY = "localization"
